import { extractPercentageStrings } from "@/hooks/useRegex";
import Discount from "./Discount";

export default function Discounts({ topOffers, translation, onCodeClick, domain, isEventPage }) {

  return (
    <div className="md:mt-16 mt-12 inner-container px-4 xl:px-0">
      <h2 className="title2">{translation?.home_h2a}</h2>
      <div className="mt-10 flex flex-col gap-3.5">
        {topOffers.map(({ offers }, index) => {
          const offer = offers[0];
          const discount = extractPercentageStrings(offer.title)[0];
          return (
            <Discount
              id={offer.id}
              merchantName={offer.merchantName}
              merchantSubdomain={offer.merchantSubdomain}
              key={index}
              url={offer.activationUrl}
              discount={discount}
              logo={offer.merchantLogo}
              hits={offer.hits}
              code={offer.code}
              link={offer.activationUrl}
              title={offer.title}
              description={offer.description}
              translation={translation}
              domain={domain}
              isEventPage={isEventPage}
              variant="small"
              onCodeClick={onCodeClick}
            />
          );
        })}
      </div>
    </div>
  );
}
